// Clipboard write with a legacy fallback: navigator.clipboard requires a
// secure context AND transient user activation — the fallback covers plain
// http dev hosts and programmatic flows. Resolves whenever a copy was
// attempted so callers can show feedback.
export const copyText = (text: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text).catch(() => legacyCopy(text));
  }

  return Promise.resolve(legacyCopy(text));
};

const legacyCopy = (text: string): void => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  textarea.remove();
};
